import { gql } from 'graphql-tag'

/**
 * Submits the post-support-conversation CSAT form (CWA `/#/support-feedback/:conversationId`).
 *
 * CWA-only: CMA has no support-feedback surface, so there is no shared document to
 * converge on. The input deliberately carries no `consumerId` — the BFF derives it from
 * the authenticated identity and rejects conversations that consumer does not own.
 * Recovered from the archived consumer-web-app repo (`src/graphql/createSupportConversationFeedback.tsx`).
 */
export const CREATE_SUPPORT_CONVERSATION_FEEDBACK = gql`
  mutation createSupportConversationFeedback($feedbackInput: SupportConversationFeedbackInput!) {
    createSupportConversationFeedback(feedbackInput: $feedbackInput) {
      conversationId
      feedback
      createdAt
      updatedAt
    }
  }
`
